import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";

export default function ProfileImageViewer(props) {
  return (
    <Modal show={props.show} className="modal fade" role="dialog">
      <Modal.Header className="modal-header">
        <Modal.Title className="modal-title text-center">
          {props.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body mbottom10">
        <img
          id="studentProfileImage"
          className="mbottom40"
          src={props.url}
          width="100%"
          alt="Profile Image"
        />
        <br />
      </Modal.Body>
      <Modal.Footer>
        <Button
          id="acceptButton"
          onClick={props.fnAcceptButton}
        >
          {props.txtBtnAccept}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ProfileImageViewer.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  txtBtnAccept: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  fnAcceptButton: PropTypes.func.isRequired,
};
